export default class Modal {
	constructor() {
		this.modalBtn = document.querySelectorAll(".jsOpenModal");
		this.closeModalBtn = document.querySelectorAll(".jsCloseModal");
		this.modalOverlay = document.querySelectorAll(".jsOverlayModal");
		this.closeAfterSaveModalBtn = document.querySelectorAll(".jsCloseModalAfterSave");
		this.body = document.body;
		this.events();
	}

	events() {
		const th = this;
		if (this.modalBtn) {
			this.modalBtn.forEach(function (modal) {
				modal.addEventListener("click", function (e) {
					e.preventDefault();
					const modalContent = document.getElementById(modal.dataset.modal);
					th.displayModal(modalContent);
				});
			});
		}

		if (this.closeModalBtn) {
			this.closeModalBtn.forEach((element) => {
				element.addEventListener("click", this.hideModal);
			});
		}

		if (this.modalOverlay) {
			this.modalOverlay.forEach((element) => {
				element.addEventListener("click", this.hideModal);
			});
		}

		if (this.closeAfterSaveModalBtn) {
			this.closeAfterSaveModalBtn.forEach((element) => {
				element.addEventListener("click", this.hideModal);
			});
		}
	}

	displayModal(modalContent) {
		modalContent.classList.add("is-open");
		this.body.classList.add("disable-scroll");
	}

	hideModal(e) {
		e.preventDefault();
		const parent = this.closest(".modal");
		if (parent.classList.contains("is-open")) {
			document.body.classList.remove("disable-scroll");
			parent.classList.remove("is-open");
		}
	}
}
